import styled from '@emotion/styled'
import { ExtranetContainer } from '@pharmac-extranet/shared'
import { PharmacIcon } from '@pharmac/ui'
import ReactDOM from 'react-dom'

interface Props {
  url: string
  hide: () => void
}

const Wrapper = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 700;
  width: inherit;
  outline: 0;
  display: flex;
  justify-content: center;
`
const Backdrop = styled.div`
  @keyframes backdrop {
    from {
      background-color: transparent;
    }
    to {
      background-color: var(--modal-overlay-background);
    }
  }
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: var(--modal-overlay-background);
  animation-name: backdrop;
  animation-duration: 0.2s;
  z-index: 500;
  cursor: zoom-out;
`

const CloseIcon = styled(PharmacIcon)`
  position: relative;
  right: 1.5rem;
  cursor: zoom-out;
`

const Image = styled.img`
  max-width: 85vw;
  max-height: 85vh;
  cursor: zoom-out;

  @media (max-width: 835px) {
    max-width: 90vw;
  }
`

export const ExtranetFullScreenImage = ({ url, hide }: Props) => {
  const modal = (
    <ExtranetContainer onClick={hide}>
      <Backdrop />
      <Wrapper>
        <Image src={url} />
        <CloseIcon icon="x" />
      </Wrapper>
    </ExtranetContainer>
  )
  return ReactDOM.createPortal(modal, document.body)
}
